/** @module Classes */ /** typedoc */
class PromolinkStats {
    constructor() {
        this.pageViews = 0;
        this.uniqueVisitors = 0;
    }
}

export { PromolinkStats };
